export enum ReportType {
    Standard,
    Midrange
}


// WEBPACK FOOTER //
// ./src/enums/ReportType.tsx